import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { AnalyticsGlobalNav } from '~/analytics/domains/page/ui/AnalyticsGlobalNav';
import { AppHeader } from '~/packages/common-frontend/layout/Header';

type Props = { children: React.ReactNode };
export const AnalyticsTemplate = ({ children }: Props): React.ReactElement => {
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        <AnalyticsGlobalNav />
        <Box width="100%" overflowX="auto">
          {children}
        </Box>
      </Flex>
    </>
  );
};
